// Define IBAN structures (position of bank identifier per country)
const ibanStructures: Record<string, { bankStart: number; bankEnd: number }> = {
  DE: { bankStart: 4, bankEnd: 12 }, // Germany
  FR: { bankStart: 4, bankEnd: 9 }, // France
  ES: { bankStart: 4, bankEnd: 8 }, // Spain
  IT: { bankStart: 4, bankEnd: 10 }, // Italy
  NL: { bankStart: 4, bankEnd: 8 }, // Netherlands
  BE: { bankStart: 4, bankEnd: 7 }, // Belgium
  AT: { bankStart: 4, bankEnd: 9 }, // Austria
  CH: { bankStart: 4, bankEnd: 9 }, // Switzerland
  SE: { bankStart: 4, bankEnd: 9 }, // Sweden
  PL: { bankStart: 4, bankEnd: 12 }, // Poland
  NO: { bankStart: 4, bankEnd: 8 }, // Norway
  DK: { bankStart: 4, bankEnd: 8 }, // Denmark
};

export function getBankIdentifier(iban: string | undefined): string | null {
  const sanitizedValue = (iban || '').replace(/\s/g, '');

  if (!sanitizedValue || sanitizedValue.length < 8) {
    return null;
  }

  const countryCode = sanitizedValue.slice(0, 2).toUpperCase();
  const structure = ibanStructures[countryCode];

  if (!structure) {
    return null; // Unsupported country
  }

  return sanitizedValue.slice(structure.bankStart, structure.bankEnd);
}

export default {
  getBankIdentifier,
};
